"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhpAppFileContentAction = void 0;
const path_1 = require("path");
const stream_utils_1 = require("../../stream-utils");
const phpAppFiles = ["composer.json", "composer.lock"];
const deletedAppFiles = phpAppFiles.map((file) => ".wh." + file);
function filePathMatches(filePath) {
    const fileName = (0, path_1.basename)(filePath);
    return phpAppFiles.includes(fileName) || deletedAppFiles.includes(fileName);
}
exports.getPhpAppFileContentAction = {
    actionName: "php-app-files",
    filePathMatches,
    callback: stream_utils_1.streamToString,
};
//# sourceMappingURL=static.js.map